import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/node_modules/next/font/google/target.css?{\"path\":\"src/app/Fonts.js\",\"import\":\"Mukta\",\"arguments\":[{\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-mukta\"}],\"variableName\":\"mukta\"}");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/node_modules/next/font/google/target.css?{\"path\":\"src/app/Fonts.js\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/public/images/planExpire/expire.webp");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/app/ReduxProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/app/Theme.js");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/src/components/common-components/plan-expired/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/layout/Layout.jsx");
;
import(/* webpackMode: "eager" */ "/data/bestdentistsurat.com/src/styles/index.css");
